import { render } from "./Boot.vue?vue&type=template&id=7a217390"
import script from "./Boot.vue?vue&type=script&lang=js"
export * from "./Boot.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Boot.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7a217390"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7a217390', __exports__)) {
    api.reload('7a217390', __exports__)
  }
  
  module.hot.accept("./Boot.vue?vue&type=template&id=7a217390", () => {
    api.rerender('7a217390', render)
  })

}


export default __exports__